// extracted by mini-css-extract-plugin
export var sbShowMain = "categories-module--sb-show-main--18rZ_";
export var wrapper = "categories-module--wrapper--1CjdB";
export var sidebar = "categories-module--sidebar--3wfIP";
export var overflow = "categories-module--overflow--2n4eP";
export var item = "categories-module--item--1TmJ5";
export var withDivider = "categories-module--withDivider--3k7sm";
export var active = "categories-module--active--2Wb_D";
export var categoriesBlock = "categories-module--categoriesBlock--OPOzV";
export var hasSearchBar = "categories-module--hasSearchBar--ccQ5q";